import api from './api';
import type { LoteMovimientoDto, LoteSaldoDto, LoteTrazabilidad } from '../types/lotes-informes';

export interface LotePaged<T> {
  items: T[];
  total: number;
  page: number;
  pageSize: number;
  resumen?: { vencidos: number; proximos: number };
}

const loteInformesService = {
  async movimientos(params: Record<string, unknown>): Promise<LotePaged<LoteMovimientoDto>> {
    const { data } = await api.get('/api/LotesInformes/movimientos', { params });
    return data;
  },

  async saldos(params: Record<string, unknown>): Promise<LotePaged<LoteSaldoDto>> {
    const { data } = await api.get('/api/LotesInformes/saldos', { params });
    return data;
  },

  async vencimientos(params: Record<string, unknown>): Promise<LotePaged<LoteSaldoDto>> {
    const { data } = await api.get('/api/LotesInformes/vencimientos', { params });
    return data;
  },

  async trazabilidad(idLote: number): Promise<LoteTrazabilidad> {
    const { data } = await api.get(`/api/LotesInformes/trazabilidad/${idLote}`);
    return data;
  },

  async movimientosPdf(params: Record<string, unknown>): Promise<Blob> {
    const { data } = await api.get('/api/LotesInformes/movimientos/pdf', {
      params,
      responseType: 'blob',
    });
    return data;
  },
};

export default loteInformesService;
